module.exports = __webpack_public_path__ + "img/nodata.afd0ac95.png";